module.exports = __webpack_public_path__ + "img/hontai_L2543.4dbc2243.png";